export default __webpack_public_path__ + "static/media/pessoa-juridica.56cf1bac.svg";